<template lang="pug">
    .top-wrap
        .top
            .logo(:style="logo",@click="$router.push({ name: 'home' })")
            .header(:style="header")
                .names
                    .title Gabriel Gnatowski
                    .sub Softwareentwicklung
            slot
</template>

<script>
export default {
    computed: {
        logo() {
            return {
                backgroundImage: "url(" + require('../assets/gg.png') + ")"
            };
        },
        header() {
            return {
                // backgroundImage: "url(" + require('../assets/header.png') + ")"
            };
        }
    }
}
</script>

<style lang="less" scoped>
@import (reference) '../shared.less';
    .top-wrap {
        margin: 0.25rem;
        // height: 3.6rem;
        filter: drop-shadow(1px 1px 3px #777);
    }
    .top {
        // border:1px solid black;
        border-radius:5px;
        height: 4.8rem;
        background-color: #eee;
        margin: 0.2rem;
        clip-path: polygon(0 0, 100% 0, 100% 70%, 5rem 70%, 3.6rem 100%, 0 100%);
        display:flex;
        align-items: center;
    }

.logo {
    flex: 0 0 auto;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 4rem;
    height: 4rem;
    margin: 0.25rem 0.25rem;
    cursor: pointer;
}
.header {
    // background-color: #eee;
    // background-position: 0 0;
    // background-repeat: no-repeat;
    // background-size: cover;
    align-self: flex-start;
    margin-top: 0.5rem;
    flex: 1 0;
    // position: absolute;
    // margin-left:4rem;
    // top: 0;
    // left: 6rem;
    // height: 4rem;
    // right: 0;
    display: flex;
    align-items: center;
}
.names {
    flex:1 0;
    display:flex;
    flex-flow:column;
    position:relative;
    align-items:baseline;
    // padding:1rem 2rem;
}
.title {
    // position:absolute;
    // left:1rem;
    // top:0.5rem;
    font-size:4vw;
    color:@c1;
    // text-shadow: #fff 0 0 4px;
    // padding:0.5rem;
}

.sub {
    color:@c1;
    font-size: 3vw;
    // text-shadow: #fff 0 0 2px;
}

@media (orientation: landscape ) {
    .top-wrap {
        height: 10vw;
        filter: drop-shadow(-1px 3px 3px #777);
    }
    .top {
        height: 8vw;
        background-color: #eee;
        margin: 1vw;
        clip-path: polygon(0 0, 100% 0, 100% 70%, 9vw 70%, 7vw 100%, 0 100%);
    }
    .logo {
        width: 6vw;
        height: 6vw;
        padding: 0.5vw;
        margin: 0.5vw;
    }
    .header {
        // left: 2.5rem;
        // height: 2rem;
        align-items: center;
    }
    .names {
        margin-top: -2.5vw;
        flex-flow: row nowrap;
        align-items: baseline;
        justify-content: space-flex-start;
    }
    .title {
        font-size:3vw;
        padding: 0 2rem;
    }
    .sub {
        font-size:2vw;
        // margin: 1rem 1rem;
    }
}

@media print {
    .top-wrap {
        display: none;
    }
}
</style>